export type Benefit = {
  tipo: string;
  descricao: string;
  quantidade: string;
  componente?: string;
  hasAds?: boolean;
};

export type Price = {
  preco_atual: number;
  preco_anterior?: number;
  ddd: string;
};

export type Loyalty = {
  tim_id: string;
  nome: string;
  descricao: string;
  descricao_omega: string;
  prioridade: number;
  oferta_especial: string;
  requer_aprovacao: number;
  ativo: number;
  precos: Price[];
};

export type ConfigurationPackage = {
  id: number;
  nome: string;
  plano_id: number;
  pacote_flashsale: number;
  pacote_portabilidade: number;
  pacote_dedicado: number;
  mostrar_bonus_portabilidade: boolean;
  mostrar_bonus_dedicado: boolean;
  inicio: string;
  fim: string;
  flash_sale: Package;
  portability: Package;
  dedicated: Package;
};

export type Package = {
  id: number;
  tim_id: string;
  nome: string;
  gb: number;
  ativo: number;
  categoria: string;
  prioridade: number;
  oferta_especial: string;
  requer_aprovacao: number;
};

export type Plan = {
  segmento: string;
  tim_id: string;
  nome: string;
  regulamento: string;
  sumario_url: string;
  correspondente: string;
  descricao: string;
  description: string;
  prioridade: number;
  gb: number;
  gbPadrao?: number;
  gbBonusPortabilidade?: number;
  gbBonusDedicated?: number;
  bonusPortabilidade?: number;
  mostrarPortabilidade?: boolean;
  mostrarDedicado?: boolean;
  pacote_configuracoes_id_substituto?: number;
  gbPromocional?: number;
  oferta_especial: string;
  requer_aprovacao: number;
  ativo: number;
  exibir_ecommerce: boolean;
  exibir_bot: boolean;
  beneficios: Benefit[];
  fidelidades: Loyalty[];
  pacotes: Package[];
  pacote_configuracoes: ConfigurationPackage;
  precos: Price[];
};
export const SEGMENTOS_POS = ["POS_EXPRESS", "POS_PAGO"];
